import { useState, useEffect, useRef, useCallback } from 'react'
import { Row } from '../../commonStyle/index.style'
import { ShowSnackbarStyle } from './index.style'
import { GREEN_CHECK_CIRCLE, RED_CROSS_CIRCLE } from '../../images'

function ShowSnackbar (props) {
  const { show, text, error } = props
  const [state, setState] = useState({
    visible: show,
    text,
    error
  })
  const timerRef = useRef(null)

  const resetState = useCallback(() => {
    setState({
      visible: false,
      text: '',
      error: false
    })
  }, [])

  ShowSnackbar.success = useCallback(({ text, visible = true }) => {
    setState({
      visible,
      text,
      error: false
    })
  }, [])

  ShowSnackbar.error = useCallback(({ text, visible = true }) => {
    setState({
      visible,
      text,
      error: true
    })
  }, [])

  useEffect(() => {
    if (state.visible) {
      timerRef.current = setTimeout(() => {
        resetState()
        clearTimeout(timerRef.current)
      }, 3000)
    }
  }, [state.visible, resetState])

  return state.visible ? (
    <ShowSnackbarStyle visible={state.visible} error={state.error}>
      <Row align='center' justify='space-between' className='snackbar-box'>
        <div className='icon-container'>
          <img src={state.error ? RED_CROSS_CIRCLE : GREEN_CHECK_CIRCLE} alt='' />
          <span>{state.text}</span>
        </div>
        <span className='snackbar-close' onClick={resetState} />
      </Row>
    </ShowSnackbarStyle>
  ) : null
}

export default ShowSnackbar
